import React from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

const InfoItem: React.FC<{
  label: string;
  fallback?: string;
  'data-testid'?: string;
}> = ({ label, children, fallback = 'N/A', 'data-testid': testId }) => (
  <Box data-testid={testId}>
    <Box
      as="label"
      sx={{
        fontSize: '12px',
        color: '#4D5659',
        mb: '2px',
        textTransform: 'uppercase',
        display: 'block',
        lineHeight: '20px',
      }}
    >
      {label}
    </Box>
    <Box
      as="span"
      sx={{
        fontSize: '14px',
        color: '#19262A',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {children || fallback}
    </Box>
  </Box>
);

type InfoRowComposition = {
  Item: React.FC<{ label: string }>;
};

const InfoRow: React.FC<{ col?: number; sx?: SxProps }> &
  InfoRowComposition = ({ children, col = 4, sx }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `repeat(${col}, 1fr)`,
      gap: '16px',
      width: '100%',
      ...sx,
    }}
  >
    {children}
  </Box>
);

InfoRow.Item = InfoItem;

export default InfoRow;
